// extracted by mini-css-extract-plugin
export default {"container":"not-found_container__YtpY5","title":"not-found_title__0lWTt","img":"not-found_img__6m3Y7"};